import { Class } from '../api/entity-constants';

export const isStock = (entity: { class: Class }) => {
  return entity.class === Class.ClassStock;
};
